<template>
  <div class="brand" v-if="brandValue">
    <v-form v-model="isFormValid" ref="form">
      <v-card class=" mb-6 pa-6">
        <v-badge v-if="!readOnly && isDifferentImage" color="pink" icon="mdi-pencil"
          style="position:absolute; top:30px ; right:30px" />
        <ImagePreview v-model="brandValue.data.image.url" v-if="brandValue.data.image">
          <template v-slot:activator>
            <v-img :src="brandValue.data.image.url" height="150" contain class="ma-2"></v-img>
          </template>
        </ImagePreview>
        <v-img v-else src="@/assets/logo_black_no_text.png" height="150" contain></v-img>
        <div class="text-center accent--text text-h6 mt-2 font-weight-light">
          Logo
        </div>
        <div class="upload-file d-flex align-center justify-center align-content-center">
          <FileInput accept="image/png, image/jpeg, image/webp" :readOnly="readOnly" label="Upload image" clearable
            v-model="brandValue.data.image" prepend-icon="mdi-image" style="max-width:250px;" />
        </div>
      </v-card>
      <v-card class="d-block rounded pt-4 px-4">
        <v-autocomplete return-object v-model="selected.translation" clearable filled hide-details item-value="code"
          item-text="reference" :items="items.translations" label="Search for a language..."
          prepend-inner-icon="mdi-magnify"></v-autocomplete>

        <v-tabs background-color="transparent" v-model="langTab" class="my-1 mt-3">
          <v-tab v-for="(l, i) in filteredLocales" :key="i" :href="`#tab-${l.code.toLowerCase()}`">
            <!--         <v-badge
              v-if="!readOnly"
              mode="in-out"
              :value="!l.data.name && !l.data.description"
              color="pink"
              icon="mdi-tooltip-edit"
            >
              {{ l.name }}
            </v-badge>
 -->
            <v-badge v-if="
              differencesLocales &&
              differencesLocales.locales &&
              differencesLocales.locales[l.code] &&
              differencesLocales.locales[l.code].name
            " color="pink" icon="mdi-pencil">
              {{ l.name }}
            </v-badge>

            <v-badge v-else :value="!l.data.name && !l.data.description" color="pink" dot>
              {{ l.name }}
            </v-badge>
          </v-tab>
        </v-tabs>
        <div class="mt-5" v-if="filteredLocales.length > 0">
          <v-tabs-items v-model="langTab">
            <v-tab-item :value="`tab-${o.code.toLowerCase()}`" v-for="(o, i) in brandValue.data.locales" :key="i">
              <div class="text-h6 accent--text">
                Brand name
                <span v-if="
                  rules.locales &&
                  rules.locales[o.code] &&
                  rules.locales[o.code].name
                " class="red--text">*
                </span>
              </div>

              <v-badge v-if="
                differencesLocales &&
                differencesLocales.locales &&
                differencesLocales.locales[o.code] &&
                differencesLocales.locales[o.code].name
              " color="pink" icon="mdi-pencil" class="d-flex justify-end  mr-4">
              </v-badge>
              <v-text-field :disabled="readOnly" outlined class="mt-3 mr-2" placeholder="Brand name here..."
                v-model="o.data.name" :rules="rules.locales && rules.locales[o.code]
                    ? rules.locales[o.code].name
                    : []
                  " />

              <!--            <div class="text-h6 accent&#45;&#45;text mb-3">Description</div>-->
              <!--            <v-textarea-->
              <!--              :disabled="readOnly"-->
              <!--              outlined-->
              <!--              no-resize-->
              <!--              v-model="o.data.description"-->
              <!--              placeholder="Enter description here..."-->
              <!--            />-->
            </v-tab-item>
          </v-tabs-items>
        </div>

        <div class="text-h6 mb-3 accent--text" v-if="filteredLocales.length > 0">
          Default Distribution
        </div>
        <v-select v-if="filteredLocales.length > 0" :rules="rules.product_perfumers ? rules.product_perfumers : []"
          :disabled="readOnly" clearable placeholder="Choose a type" dense
          v-model="brandValue.data.default_distribution" :items="brand_distributions" item-text="label" item-value="id"
          outlined></v-select>

        <EmptyListPlaceholder :height="250" v-if="filteredLocales <= 0" :is-loading="false"
          message="You don't have this language in the list" :message-size="17" :icon="'mdi-translate'" :icon-size="40">
          <v-btn class="mt-2" text color="primary" @click="addLocale(selected.translation)" v-if="!readOnly">
            <v-icon left>mdi-plus</v-icon>
            Add this language (translation)</v-btn>
        </EmptyListPlaceholder>
      </v-card>
    </v-form>
  </div>
  <!-- <div class="text-h6 accent--text">Brand name</div>
    <v-text-field
      @input="emitValue"
      outlined
      :disabled="!edit"
      class="mt-3"
      v-model="brandValue.name"
    />
    <div class="text-h6 accent--text mb-3">Description</div>
    <v-textarea
      v-if="brandValue.data"
      @input="emitValue"
      outlined
      no-resize
      :disabled="!edit"
      v-model="brandValue.data.description"
    />
  </div> -->
</template>

<script>
// import { BRAND_DISTRIBUTIONS } from "@/data"
import EmptyListPlaceholder from "@/components/base/EmptyListPlaceholder"
import DistributionService from "@/services/perfumist/ExtraFieldsService"
import FileInput from "@/components/inputs/FileInput.vue"
import { TRANSLATIONS } from "@/data"
import { capitalize, cloneDeep } from "lodash"
import { required } from "@/utils/validator"
export default {
  components: {
    FileInput,
    EmptyListPlaceholder,
    ImagePreview: () => import("@/components/perfumist/ImagePreview")
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isDifferentImage: {
      type: Boolean,
      default: false
    },
    differencesLocales: {
      type: Object,
      default: null
    },
    brand: {
      type: Object,
      default: () => ({
        name: "",
        default_distribution: "",
        data: {
          description: "",
          image: ""
        }
      })
    },
    langTabIndex: {
      type: String,
      default: "tab-en"
    }
  },
  methods: {
    getBrandDistributions() {
      DistributionService.get(this, "distribution")
        .then(r => {
          this.brand_distributions = r.results || []
        })
        .finally(() => {
          // this.loading.product_notes = false
        })
    },
    addLocale(locale) {
      const loc = {
        code: locale.code.toLowerCase(),
        name: locale.reference,
        default_distribution: "",
        data: {
          name: "",
          description: ""
        }
      }
      this.brandValue.data.locales.push(loc)
      // this.brandValue.data.default_distribution 
      this.selected.translation = null
      this.$emit("addLocale", cloneDeep(loc))
      this.$nextTick(() => {
        this.langTab = "tab-" + locale.code.toLowerCase()
      })
    }
  },
  watch: {
    langTabIndex(newValue, oldValue) {
      this.langTab = newValue
    },
    langTab(newValue, oldValue) {
      this.$emit("onLangTabChange", newValue)
    },
    brandValue: {
      deep: true,
      handler(newValue, oldValue) {
        // const old = this.brandValue
        // const current = {
        //   ...this.brandValue,
        //   data: { ...this.brandValue.data, locales: newValue }
        // }
        if (
          newValue !== null &&
          !this.readOnly &&
          !this.lo.isEqual(newValue, oldValue)
        ) {
          this.$emit("input", newValue)
        }
      }
    },
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (!this.lo.isEqual(newValue, this.brandValue)) {
          this.localesValue = newValue
          this.brandValue = this.lo.cloneDeep(newValue)
          this.localesValue = this.lo.cloneDeep(this.value.data.locales)
        }
      }
    },

    // tabIndex(newValue, oldValue) {
    //   this.tab = newValue
    // },
    // tab(newValue, oldValue) {
    //   this.$emit("onTabChange", newValue)
    // },
    brand(newValue, oldValue) {
      if (newValue !== null) this.brandValue = this.lo.cloneDeep(newValue)
    },
    isFormValid(newValue) {
      this.$emit("isFormValid", newValue)
    }
  },
  created() {
    this.getBrandDistributions()
  },
  mounted() {
    if (this.value !== null) {
      this.brandValue = this.lo.cloneDeep(this.value)
      // this.localesValue = this.lo.cloneDeep(this.value.data.locales)
    } else if (this.brand !== null) {
      this.brandValue = this.lo.cloneDeep(this.brand)
    }
  },
  data() {
    return {
      isFormValid: null,
      image: null,
      brandValue: null,
      default_distribution: "",
      brand_distributions: [],
      tab: 1,
      langTab: "tab-1",
      selected: {
        translation: null
      },
      items: {
        translations: TRANSLATIONS.map(t => ({
          ...t,
          reference: capitalize(t.reference.replace("_", ""))
        }))
      }
    }
  },
  computed: {
    filteredLocales() {
      return (this.brandValue?.data?.locales || []).filter(curr =>
        this.selected.translation
          ? [this.selected.translation.code.toLowerCase()].includes(
            curr.code.toLowerCase()
          )
          : true
      )
    },
    edit() {
      return !!this.value
    },
    rules() {
      return {
        locales: { en: { name: [required] } }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
